import { Popover, PopoverContent, PopoverTrigger } from '@/components/design-system/popover';
import type { MenuItem } from '@/consts/navigation';
import { useTranslation } from 'react-i18next';

import { NavMenuItemsList } from './NavMenuItemsList';

interface NavHoverPopoverProps {
  item: MenuItem;
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  children: React.ReactNode;
}

export const NavHoverPopover = ({ item, isOpen, onOpenChange, children }: NavHoverPopoverProps) => {
  const { t } = useTranslation();
  const hasChildren = item.children && item.children.length > 0;

  if (!hasChildren) {
    return <>{children}</>;
  }

  return (
    <Popover open={isOpen} onOpenChange={onOpenChange}>
      <PopoverTrigger asChild>{children}</PopoverTrigger>
      <PopoverContent
        side="right"
        align="start"
        sideOffset={8}
        collisionPadding={{ top: 20, left: 20, bottom: 20 }}
        className="bg-secondary-600 nav-scrollbar-auto max-h-[400px] overflow-y-auto rounded-md border-none p-0"
        onPointerDownOutside={(e) => {
          e.preventDefault();
        }}
      >
        <div className="bg-secondary-500 flex h-10 items-center gap-2.5 rounded-t px-4">
          <p className="text-typography/85 flex-1 overflow-hidden text-sm leading-[22px] font-semibold text-ellipsis whitespace-nowrap uppercase">
            {t(item.text)}
          </p>
        </div>

        <NavMenuItemsList
          items={item.children ?? []}
          variant="popover"
          isUtilitySection={item.text === 'navigation.recent.title' || item.text === 'navigation.favorites.title'}
        />
      </PopoverContent>
    </Popover>
  );
};
